export function trimStringFields<T>(obj: T): T {
    Object.keys(obj as any).forEach(key => {
      if (typeof (obj as any)[key] === 'string') {
        (obj as any)[key] = (obj as any)[key].trim();
      }
    });
    return obj;
  }